// extracted by mini-css-extract-plugin
export default {"resultcontainer":"resultdisplay_resultcontainer__TDbws"};